module.exports = __webpack_public_path__ + "img/SB.d711c7cb.svg";